import { Injectable } from '@angular/core';
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  private toggleSidebar$ = new Subject<void>();

  // Observable that components can subscribe to
  public sidebarToggle = this.toggleSidebar$.asObservable();

  // Method to call when toggle button is clicked
  toggleMobileSidebar(): void {
    this.toggleSidebar$.next();
  }

}
